<template>
    <hts-tooltip>
        <template #reference>
            <hi-pencil-square-icon
                class="h-4 w-4 cursor-pointer transition-all hover:text-gray-500"
                :class="{
                    '!text-gray-700': cValue,
                    '!text-gray-300': !cValue
                }"
                @click="cValue = !cValue" />
        </template>
        <span>
            {{ label }}
        </span>
    </hts-tooltip>
</template>
<script setup lang="ts">
import { computed, toRefs } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean
  },
  label: {
    type: String,
    default: 'Tắt/mở chỉnh sửa tuyến trên bản đồ'
  }
})

const { modelValue, label } = toRefs(props)

const cValue = computed({
  get: () => {
    return modelValue.value
  },
  set: (value: boolean) => {
    modelValue.value = value
    emits('update:modelValue', value)
  }
})

const emits = defineEmits(['update:modelValue'])
</script>
